import AdvocateCharishmaDetails from '../../components/about/advocates-details/charishma';
import Footer from '../../components/common/footer';
import Layout from '../../components/common/layout';
import NavigationMenu from '../../components/common/navigationMenu';
import PageHeader from '../../components/common/pageHeader';
import React from 'react';

const AdvocateCharishmaDetailsPage = () => {
  return (
    <Layout pageTitle='Avadhani & Associates | Charishma Atla'>
      <NavigationMenu active='about' />
      <PageHeader
        title='Charishma Atla'
        subMenu='Advocates'
        backLink='/about#team-section'
      />
      <AdvocateCharishmaDetails />
      <Footer />
    </Layout>
  );
};

export default AdvocateCharishmaDetailsPage;
